import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import { Alert, Avatar, Breadcrumbs, Button, Divider, IconButton, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Snackbar, Stack } from '@mui/material';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import VillaOutlinedIcon from '@mui/icons-material/VillaOutlined';
import EditRoadOutlinedIcon from '@mui/icons-material/EditRoadOutlined';
import AddRoadOutlinedIcon from '@mui/icons-material/AddRoadOutlined';
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined';
import MedicalInformationOutlinedIcon from '@mui/icons-material/MedicalInformationOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import StackedBarChartOutlinedIcon from '@mui/icons-material/StackedBarChartOutlined';
import Common from '../../utilities/common';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import $ from "jquery";
import SecurityTrimmer from './SecurityTrimmer';
import NotificacionSnackbar from '../../Notificaciones/NotificacionSnackbar';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import Logout from '@mui/icons-material/Logout';
import { BreadCrumb } from '../BreadCrumbModel';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import MediationOutlinedIcon from '@mui/icons-material/MediationOutlined';
import FeatureManager from './FeatureManager';

export interface ILayoutProps {
    children: string | JSX.Element | JSX.Element[];
    breadcrumb?: BreadCrumb[];
    openForm?: boolean;
    sendTo?: number;
    entity?: Entity;
}

export interface ILayoutState {
    menuOpened: boolean;
    checkingPermission: boolean;
    openUserMenu: boolean;
    anchorEl: null | HTMLElement;
    openNotificationForm: boolean;
}

export default class Layout extends React.Component<ILayoutProps, ILayoutState> {
    public constructor(props: ILayoutProps) {
        super(props);

        this.state = {
            menuOpened: false,
            checkingPermission: true,
            openUserMenu: false,
            anchorEl: null,
            openNotificationForm: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<ILayoutProps>, nextContext: any): void {
        this.setState(
            {
                openNotificationForm: nextProps.openForm!
            }
        )
    }

    componentDidMount(): void {
        this.CheckToken();
    }

    public render(): React.ReactElement<{}> {
        return (
            <div>
                {
                    Common.GetUrlParam('isdlg') != '1' && (
                        <Box sx={{ flexGrow: 1 }}>   
                            <AppBar position="static">
                                <Toolbar>
                                    <IconButton
                                        size="large"
                                        edge="start"
                                        color="inherit"
                                        sx={{ mr: 2 }}
                                        onClick={() => {
                                            this.setState(
                                                {
                                                    menuOpened: !this.state.menuOpened
                                                }
                                            );
                                            if((document.querySelector('.sidebar')! as HTMLElement).style.width == "350px") {
                                                (document.querySelector('.sidebar')! as HTMLElement).style.width = "0px";
                                            }
                                            else {
                                                (document.querySelector('.sidebar')! as HTMLElement).style.width = "350px";
                                            }
                                        }}
                                    >
                                        {
                                            !this.state.menuOpened && (
                                                <MenuIcon />
                                            )
                                        }
                                        {
                                            this.state.menuOpened && (
                                                <CloseOutlinedIcon />
                                            )
                                        }
                                    </IconButton>
                                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                                        AD735 Data Manager
                                    </Typography>
                                    <Button color="inherit" onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                        this.setState(
                                            {
                                                anchorEl: event.currentTarget,
                                                openUserMenu: true
                                            }
                                        );
                                    }}>
                                        <Stack direction={'row'} spacing={1}>
                                            <Avatar src={Common.GetUserProp('avatar')} sx={{ width: 32, height: 32, bgcolor: Common.GetUserProp('avatarColor') }}>
                                                <Typography variant='caption' style={{position: 'relative', top: '2px'}}>
                                                    {
                                                        Common.GetNameInitials(`${Common.GetUserProp('nombre')} ${Common.GetUserProp('apellidos')}`)
                                                    }
                                                </Typography>
                                            </Avatar>
                                            <Typography variant='body2' style={{position: 'relative', top: '7px'}}>
                                                {
                                                    `${Common.GetUserProp('nombre')} ${Common.GetUserProp('apellidos')}`
                                                }
                                            </Typography>
                                        </Stack>
                                    </Button>
                                    <NotificacionSnackbar openForm={this.state.openNotificationForm} entity={this.props.entity} sendTo={this.props.sendTo}/>
                                </Toolbar>
                            </AppBar>
                            <Menu
                                id="basic-menu"
                                anchorEl={this.state.anchorEl}
                                open={this.state.openUserMenu}
                                onClose={() => {
                                    this.setState(
                                        {
                                            openUserMenu: false
                                        }
                                    )
                                }}
                                PaperProps={{
                                    elevation: 0,
                                    sx: {
                                      overflow: 'visible',
                                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                      mt: 1.5,
                                      '& .MuiAvatar-root': {
                                        width: 32,
                                        height: 32,
                                        ml: -0.5,
                                        mr: 1,
                                      },
                                      '&::before': {
                                        content: '""',
                                        display: 'block',
                                        position: 'absolute',
                                        top: 0,
                                        right: 14,
                                        width: 10,
                                        height: 10,
                                        bgcolor: 'background.paper',
                                        transform: 'translateY(-50%) rotate(45deg)',
                                        zIndex: 0,
                                      },
                                    },
                                }}
                                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                            >
                                <MenuItem onClick={() => {
                                    window.location.href = '/perfil';
                                }}>
                                    <Avatar src={Common.GetUserProp('avatar')} sx={{ width: 32, height: 32, bgcolor: Common.GetUserProp('avatarColor') }}>
                                        <Typography variant='caption' style={{position: 'relative', top: '2px'}}>
                                            {
                                                Common.GetNameInitials(`${Common.GetUserProp('nombre')} ${Common.GetUserProp('apellidos')}`)
                                            }
                                        </Typography>
                                    </Avatar>
                                    Mi perfil
                                </MenuItem>
                                <MenuItem onClick={() => {
                                    localStorage.removeItem('user');
                                    window.location.href = '/login';
                                }}>
                                    <ListItemIcon>
                                        <Logout fontSize="small" />
                                    </ListItemIcon>
                                    Cerrar sesión
                                </MenuItem>
                            </Menu>
                        </Box>
                    )
                }
                {
                    Common.GetUrlParam('isdlg') != '1' && (
                        <Paper square elevation={3} className='sidebar'>
                            <List disablePadding>
                                <SecurityTrimmer entity={Entity.Dashboard} permission={PermissionLevel.Ver}>
                                    <ListItem disablePadding>
                                        <ListItemButton onClick={() => {
                                            window.location.href = "/";
                                        }}>
                                            <ListItemIcon>
                                                <StackedBarChartOutlinedIcon/>
                                            </ListItemIcon>
                                            <ListItemText primary={'Inicio'} />
                                        </ListItemButton>
                                    </ListItem>
                                    <Divider />
                                </SecurityTrimmer>
                                <FeatureManager entidad={Entity.Normalizaciones} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.Normalizaciones} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/normalizaciones";
                                            }}>
                                                <ListItemIcon>
                                                    <SettingsSuggestOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Normalizaciones'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Consolidaciones} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.Consolidaciones} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/consolidaciones";
                                            }}>
                                                <ListItemIcon>
                                                    <StorageOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Consolidaciones'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Extracciones} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.Extracciones} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/extracciones";
                                            }}>
                                                <ListItemIcon>
                                                    <ExitToAppOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Extracciones'} />
                                            </ListItemButton>
                                        </ListItem>
                                        <Divider />
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Verticales} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.Verticales} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/verticales";
                                            }}>
                                                <ListItemIcon>
                                                    <MediationOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Verticales'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Clientes} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.Clientes} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/clientes";
                                            }}>
                                                <ListItemIcon>
                                                    <HandshakeOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Clientes'} />
                                            </ListItemButton>
                                        </ListItem>
                                        <Divider />
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.ComunidadesAutonomas} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/comunidadesautonomas";
                                            }}>
                                                <ListItemIcon>
                                                    <HomeWorkOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Comunidades autónomas'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Provincias} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/provincias";
                                            }}>
                                                <ListItemIcon>
                                                    <HolidayVillageOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Provincias'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Municipios} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.Municipios} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/municipios";
                                            }}>
                                                <ListItemIcon>
                                                    <VillaOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Municipios'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.VariacionesMunicipios} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.VariacionesMunicipios} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/municipiosvariaciones";
                                            }}>
                                                <ListItemIcon>
                                                    <VillaOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Variaciones de municipios'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.TiposVía} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.TiposVía} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/tiposvia";
                                            }}>
                                                <ListItemIcon>
                                                    <EditRoadOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Tipos de vía'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.VariacionesTiposVía} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.VariacionesTiposVía} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/tipoviavariaciones";
                                            }}>
                                                <ListItemIcon>
                                                    <AddRoadOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Variaciones de tipos de vía'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Tramero} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.Tramero} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/tramero";
                                            }}>
                                                <ListItemIcon>
                                                    <MyLocationOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Tramero'} />
                                            </ListItemButton>
                                        </ListItem>
                                        <Divider />
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.NombresPila} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.NombresPila} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/nombresdepila";
                                            }}>
                                                <ListItemIcon>
                                                    <BadgeOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Nombres de pila'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.VariacionesNombresPila} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.VariacionesNombresPila} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/variacionesnombresdepila";
                                            }}>
                                                <ListItemIcon>
                                                    <MedicalInformationOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Variaciones de nombres de pila'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Apellidos} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.Apellidos} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/apellidos";
                                            }}>
                                                <ListItemIcon>
                                                    <BadgeOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Apellidos'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.VariacionesApellidos} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.VariacionesApellidos} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/masters/variacionesapellidos";
                                            }}>
                                                <ListItemIcon>
                                                    <MedicalInformationOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Variaciones de apellidos'} />
                                            </ListItemButton>
                                        </ListItem>
                                        <Divider/>
                                    </SecurityTrimmer>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Configuracion} operacion='Ver'>
                                    <SecurityTrimmer entity={Entity.Configuracion} permission={PermissionLevel.Ver}>
                                        <ListItem disablePadding>
                                            <ListItemButton onClick={() => {
                                                window.location.href = "/settings";
                                            }}>
                                                <ListItemIcon>
                                                    <SettingsOutlinedIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={'Configuración'} />
                                            </ListItemButton>
                                        </ListItem>
                                    </SecurityTrimmer>
                                </FeatureManager>
                            </List>
                        </Paper>
                    )
                }
                <Box sx={{ flexGrow: 1, padding: '20px', maxWidth: ['70%', '80%', '90%'], margin: '0 auto' }} id='main'>
                    {
                        this.props.breadcrumb != null && this.props.breadcrumb.length > 0 && (
                            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} style={{marginBottom: '20px'}}>
                                {
                                    this.props.breadcrumb != null && this.props.breadcrumb.map((breadCrumb: BreadCrumb, index: number) => {
                                        if(this.props.breadcrumb!.length == 1 || index < this.props.breadcrumb!.length - 1) {
                                            return (
                                                <Link underline='none' color="text.primary" href={breadCrumb.url} fontSize={'12px'} key={index}>
                                                    {
                                                        index == 0 && (
                                                            <HomeIcon fontSize='medium' style={{position: 'relative', top: '3px'}}/>
                                                        )
                                                    }
                                                    {
                                                        index > 0 && (
                                                            breadCrumb.title
                                                        )
                                                    }
                                                </Link>
                                            )
                                        }
                                        else {
                                            return (
                                                <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }} fontSize={'12px'} key={index}>
                                                            {
                                                        breadCrumb.title
                                                    }
                                                </Typography>
                                            )
                                        }
                                    })
                                }
                            </Breadcrumbs>
                        )
                    }
                    {
                        this.props.children
                    }
                </Box>
            </div>
        )
    }

    private CheckToken() {
        let url = `${Common.END_POINT}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: string) => {
            console.log(response);
        }).fail(( jqXHR, textStatus, errorThrow) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        })
    }
}